export default {
  weeks: {
    id: 'plp_countdown_weeks_short',
    defaultMessage: 'wk',
  },
  days: {
    id: 'plp_countdown_days_short',
    defaultMessage: 'dy',
  },
  hours: {
    id: 'plp_countdown_hours_short',
    defaultMessage: 'hr',
  },
  minutes: {
    id: 'plp_countdown_minutes_short',
    defaultMessage: 'min',
  },
  seconds: {
    id: 'plp_countdown_seconds_short',
    defaultMessage: 'sec',
  },
}
